import { useEffect, useState, useContext } from 'react'

import { history } from 'services/history.js'
import { showLoading } from 'services/util'
import { ThemeContext } from 'ThemeContext'
import { urlQueryParser } from 'services/util'

import * as api from './paymentapi'
import UpdatePaymentForm from './UpdatePaymentForm'
import GiftsAssociatedGrid from './GiftsAssociatedGrid'

import css from '../payment/sass/payments.module.scss'

// const testInput = {
//   "publicId": "3b2eeb16-4839-4c8e-9e7c-621f4e3ebc2a",
//   "revenueId": "579d953f-d540-4b47-b16b-d9d96b284b3a"
// }

function NonAuthPaymentUpdate(props) {
  const theme = useContext(ThemeContext)
  const [associatedGifts, setAssociatedGifts] = useState([]);
  const [clientInstance, setClientInstance] = useState()
  const [loadError, setLoadError] = useState()

  const { pid: publicId, rid: revenueId, test: testWithActiveCard } = urlQueryParser(props.location.search)

    useEffect(() => {
    const formLoadError = 'Oops something went wrong. Please try again or contact Donor Relations support at ' + theme.supportPhone + '.';
    showLoading(true)

    async function setup() {
      try {
        const [gifts, client] = await Promise.all([
          api.getGiftDetails(publicId, revenueId, testWithActiveCard === 'Y'),
          api.getBraintreeClientInstance(true),
        ])

        setAssociatedGifts(gifts)
        setClientInstance(client)

        showLoading(false)
      }
      catch (e) {
        setLoadError(formLoadError)
        console.error({msg: 'Error loading payment form.', e})
        showLoading(false)
      }
    }

    setup()

    return () => {
      setClientInstance();
      // setLoadError(formLoadError)
    }
  }, [theme, publicId, revenueId, testWithActiveCard])

  const doPostSuccess = (newCard) => {
    history.push({ pathname: '/ccupdatesuccess', state: { updatedCard: true} });
  };

  if (loadError) {
    return (
      <div className={css['payment-method-body']}>
        <p className={css.copy}>{loadError}</p>
      </div>
    )
  }

  return (
    <div className={css['payment-method-body']}>
      <h1 id="nonAuthUpdatePaymentTitle" className={css['payment-method-header']}>Update Payment Card For Following Gift(s)</h1>

      <p className={`${css['payment-method-body__copy']} ${css['p-zero-spacing']}`}>
        <div>
          The payment card associated with the following gift(s) is expired.
          <br/>
          Please add a new valid payment card to ensure your gifts may continue uninterrupted.
        </div>
      </p>

      <div className={css['non-auth-payment-method']}>
        <GiftsAssociatedGrid gifts={associatedGifts} />

        {clientInstance &&
          <UpdatePaymentForm
            clientInstance={clientInstance}
            revenueLookupIdArray={associatedGifts.map(gift => gift.revenueLookupId)}
            associatedGifts={associatedGifts}
            doPostSuccess={doPostSuccess}
            publicId={publicId}
            isNonAuth={true}
            loadError={loadError} />}
      </div>
    </div>
  )
}

export default NonAuthPaymentUpdate